export const navigateFromDocumentLibrary = ({ navigate, childId = '', itemId = '' } = {}) => {
  if (itemId === 'home') navigate('/home');
  if (itemId === 'today') navigate('/dashboard', { state: { selectedChildId: childId, childShellTarget: 'today' } });
  if (itemId === 'profile') navigate('/care-profile', { state: { childId } });
  if (itemId === 'tools') navigate('/dashboard', { state: { selectedChildId: childId, childShellTarget: 'tools' } });
};
